import React, { Component } from 'react';
import {Row, Col, Label, Input, FormText, FormGroup, Button,Popover, PopoverHeader, PopoverBody} from 'reactstrap';
import {uploadEmployeeDataSteps,mapType} from './../../../utils/constants';
import Steps from '../../../components/Steps/Steps';
import InfoMessage from '../../../components/Message/InfoMessage/InfoMessage';
import DatePicker from "react-datepicker";
import Papa from 'papaparse';
import ReviewAlert from '../../../components/OrganizationSetup/Components/Review/ReviewAlert/ReviewAlert';
import moment from 'moment';
import Select from 'react-select';
import Tooltip from '../../../components/UI/TooltipIcon/TooptipIcon';


class UploadFile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      file: {
        value: this.props.file,
        error: false,
        errorMessage: ''
      },
      fileType:[{value:null, label:"Please select an option", disabled:true}, {value:"Employee", label:"Employee", disabled:false}, {value:"ATS", label:"Applicant", disabled:false}], 
      selectedType: '', 
      error:false,
      errorMsg:"Please select a file type",
      fileTypeDefinition:false
    }
  }

  componentDidMount() {
    const datePickerEffectiveDate = document.getElementsByClassName('react-datepicker__input-container')[0];
    datePickerEffectiveDate.childNodes[0].setAttribute('readOnly', true);
}

  toggleDefinitionPopover = () => this.setState({fileTypeDefinition: !this.state.fileTypeDefinition});


  handleFileUpload = ({target}) => {

    let allowedFileSize = 20;
    let uploadFileHint = '(Only .csv files, maximum 20MB file size)';
    let file = target.files[0];
    // console.log(file)
    if(file){
      let fileExtension = file.name.split('.')[file.name.split('.').length - 1];
    if(!['csv'].includes(fileExtension.toLowerCase())) {
      this.setState({file: {value: '', error: true, errorMessage: `${uploadFileHint}`}});
    } else if(file.size > (1024 * 1024 * allowedFileSize)) {
      this.setState({file: {value: '', error: true, errorMessage: `Upload file size is more that ${allowedFileSize}MB`}});
    } else {
      this.setState({file: {value: file, error: false, errorMessage: ''}, fileName: file.name});
    }
    this.props.fileUploadName(file)
    } 
  }

  processFile = () => {
    let csvFile = this.state.file.value;
    let selectedType = this.state.selectedType;
    //console.log("selectedType", selectedType);
    // console.log("")
    if (!csvFile || !csvFile.name) {
      this.setState({file: {value: csvFile, error: true, errorMessage: 'Please select file.'}})
    } else if (!selectedType || selectedType===""){
      this.setState({error: true})
      //console.log('state --- ', this.state.error)
    } else {
      Papa.parse(csvFile, {
        header: true,
        dynamicTyping: true,
        skipEmptyLines:'greedy',
        complete: this.handleCsvParseComplete
      });
    }
  }

  handleCsvParseComplete = (result,file) => {
    const { fields } = result.meta;
    const {data} = result;
    console.log(result, file);
    this.props.onFileUpload(fields, data, this.state.file.value);
   }
  //  first functionality needs to work.
   onChangeSelect = (selectedType) => {
    var val = selectedType.target.value;
    let dataType = val && val !==null ? val:"" 
    this.setState({ selectedType: dataType}) 
    this.props.onFileTypeSelect(dataType); 
  }

  openDatePicker = (id) => {
      document.getElementById(id).click();
  }

  render() { 
    let {file, selectedType, fileType} = this.state;
    const {selectedDate} = this.props;
    //console.log(this.props);
    let fileValues = this.state.fileType.map(e=>e)
    let error = this.state.error
    let errMsg = this.state.errorMsg
    return ( 
      <div className="">
        <div className="title-text">
          Import from a File
        </div>
        <Steps
          steps={uploadEmployeeDataSteps}
          currentStep={1}
        />
        <Row>
          <Col className="upload-file-instruction">
            Please upload your data file. Next, you can match columns of the file to information 
            needed to calculate your KPIs.
          </Col>
        </Row>
      <div className="mt40">
        
        <div className="row" style={{justifyContent:'center'}}>
          <div className="upload-file-type-lable col-md-2 col-lg-2" style={{textAlign:'right'}}>
            File Date
          </div>
          <div className="col-lg-3 col-md-3">
            <div className="inner-addon right-addon">
              <span className="tool-start-date flaticon-calendar" onClick={() => this.openDatePicker("selectFileDate")} />
              <DatePicker
                id="selectFileDate"
                placeholderText="Enter goal date"
                className="input-custom-date form-control"
                showYearDropdown
                onChange={this.props.onDateChanged}
                selected={selectedDate}
                maxDate={moment()}
              />
            </div>
          </div>
          <div className="col-lg-3 col-md-3"></div>
        </div>


        <div className="row mt20" style={{justifyContent:'center'}}>
          <div className="upload-file-type-lable col-md-2 col-lg-2" style={{textAlign:'right'}}>
            File Name
          </div>
          <div className="col-lg-3 col-md-3">
            <Label for="file-upload" className="custom-file-upload" style={{width:'100%',textAlign:'center'}}>
                <span className="select-file">Select File</span>
            </Label>
            <input 
              id="file-upload" 
              onChange={this.handleFileUpload} 
              type="file" 
              accept=".csv,.CSV"/>
            <FormText>
            </FormText>
            {file.error ? <span className="upload-file-err-msg">
              {file.errorMessage}</span> : null}
          </div>
          <div className="col-lg-3 col-md-3">
            <div className="no-file-chosen mt5" style={{textAlign:'start'}}>
            {(file.value && file.value!=="" && file.value.name) ? file.value.name : 
            'No File Chosen'}</div>
          </div>
        </div>
        <div className="row">
          <div className="upload-file-hint offset-md-4 col-md-4 offset-lg-4 col-lg-4">
            (Only .csv files, maximum 20MB file size)
          </div>
        </div>

        <div className="row mt20" style={{justifyContent:'center'}}>
          <div className="upload-file-type-lable col-md-4 col-lg-4" style={{textAlign:'right'}}>
                  <span id="fileType-popover" style={{ marginRight: "10px"}} onClick={this.toggleDefinitionPopover}>
                    <Tooltip />
                  </span>
                  <span className="chartLabel">Select File Type</span>
                  <Popover placement="left" isOpen={this.state.fileTypeDefinition} target="fileType-popover" toggle={this.toggleDefinitionPopover}>
                    <PopoverHeader className="popover-header-tooltip">
                    Select File Type
                    </PopoverHeader>
                    <PopoverBody className="popover-body-tooltip">
                    Please select whether you are uploading a file with your applicant data OR
                   with your employee data
                    </PopoverBody>
                  </Popover>
          </div>
          <div className="col-lg-4 col-md-4">
            <div className="inner-addon right-addon">
              <FormGroup>
                <Input type="select" name="select" id="exampleSelect" placeholder="Please select an option" onChange={this.onChangeSelect}>
                { 
                  fileType.map((e, idx)=>{
                    return(
                      <option key={e.value} value={e.label}>{e.label}</option>
                    )
                  })
                }
                </Input>
              </FormGroup>
              {/* <Select
                  placeholder="Please select an option"
                  value={ selectedType }
                  options={fileType.map(e=>e)}
                  onChange={this.onChangeSelect} 
                  /> */}
            </div>
          </div>
          <div className="col-lg-4 col-md-4">
          {error ? <p> <span className="upload-file-err-msg">
              {errMsg}</span> </p>: null}
          </div>
        </div>
      </div>
      <ReviewAlert 
        type={mapType.uploadEmployeeDataCsv}
        reviewHeading={'Please make sure the file contains data for ALL employees OR applicants to be included in the KPI calculations.'}
        message={'Please do NOT upload partial data sets containing only some of your employees, such as new hires, or separated employees, as this will cause your KPIs to be mis-calculated.'}
      />
      <Row className="mt40">
        <Col sm={{ size: '6', offset: 6 }}>
          <Col sm={{ size: '6', offset: 6 }}>
          <Button
            className="float-right continueBtn w100 clearfix mb10"
            onClick={this.processFile}
          >
            <span className="continueBtnTxt">Continue <span className="ml10 flaticon-next"></span></span>
          </Button>
          </Col>
        </Col>
      </Row>
    </div>
    );
  }
}
 

export default UploadFile;